import { createRouter } from '@tanstack/react-router';
import type { User } from './db/schema';
import { routeTree } from './routeTree.gen';

export interface RouterContext {
  auth: {
    isAuthenticated: boolean;
    isLoading: boolean;
    user?: User;
  };
}

export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
  },
});
